<template>
  <div class="container">
    <div class="block1">
      <img src="../assets/images/m.38cc7705.svg">
      <span class="s1">{{ $t("common.totalBalance") }}</span>
      <span class="s2">{{data.totalBalance}} <span class="trx">USDT</span></span>
    </div>
    <div class="block2">
      <div class="deposit" @click="$router.push('/deposit')">
        <van-icon name="paid" size="10.667rem"/>
        <span>{{ $t("common.deposit") }}</span>
      </div>
      <div class="withdrawal" @click="$router.push('/withdrawal')">
        <van-icon name="exchange" size="10.667rem"/>
        <span>{{ $t("common.withdrawal") }}</span>
      </div>
    </div>
    <div class="block3">
      <div class="block3-1">
        <div class="l1">
          <span>{{ $t("minePage.trxDepositInvestment") }}: {{data.investmentBalance}} USDT</span>
          <van-icon name="replay" />
        </div>
        <span class="l2">{{ $t("minePage.trxDepositFinancial") }}: {{data.financialBalance}} USDT</span>
        <span>{{ $t("minePage.tips") }}</span>
      </div>
      <div class="block3-2">
        <div style="margin-bottom:2.133rem;">{{ $t("minePage.appServices") }}</div>
        <div class="service" @click="$router.push('/team')">
          <img src="../assets/images/services-1.png">
          <span>{{ $t("common.team") }}</span>
        </div>
        <div class="service" @click="$router.push('/profitList')">
          <img src="../assets/images/services-2.png">
          <span>{{ $t("common.profitList") }}</span>
        </div>
        <div class="service" @click="$router.push('/investedList')">
          <img src="../assets/images/services-3.png">
          <span>{{ $t("investPage.investedList") }}</span>
        </div>
        <div class="service" @click="$router.push('/share')">
          <img src="../assets/images/services-4.png">
          <span>{{ $t("common.share") }}</span>
        </div>
        <div class="service" @click="$router.push('/notification')">
          <img src="../assets/images/services-5.png">
          <span>{{ $t("common.notification") }}</span>
        </div>
        <div class="service" @click="$router.push('/task')">
          <img src="../assets/images/services-6.png">
          <span>{{ $t("common.task") }}</span>
        </div>
        <div class="service" @click="logout">
          <img src="../assets/images/services-7.png">
          <span>{{ $t("common.logout") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'mine',
  data() {
    return {
      data: {
        totalBalance: 0,
        investmentBalance: 0,
        financialBalance: 0
      }
    }
  },
  mounted() {
      this.token = localStorage.getItem('token');
      this._fetch();
  },
  methods: {
    _fetch() {
        this.apiV1({
            method: 'get',
            url: '/mine',
            headers: {'Authorization': this.token}
        }).then(response => {
            const { success, data } = response.data;
            if (success) {
                this.data = data;
            }
        })
    },
    logout() {
      localStorage.removeItem('addr');
      localStorage.removeItem('token');
      location.reload();
    }
  }
}
</script>
<style scoped lang="less">
.container {
  padding: @nav-bar-height 0 @tabbar-height;
  display: flex;
  flex-direction: column;
  .block1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10.667rem;
    img {
          width: 24rem;
    }
    .s1 {
      color: antiquewhite;
      font-size: 3.2rem;
    }
    .s2 {
      font-size: 8rem;
      font-weight: bold;
    }
    .trx {
      font-size: 4rem;
      color: antiquewhite;
    }
  }
  .block2 {
    display: flex;
    margin-top: 5.333rem;
    color: antiquewhite;
    align-self: center;
    z-index: 9;
    .deposit, .withdrawal {
      width: 30rem;
      height: 22rem;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      border-radius: 4rem;
      span {
        font-size: 3.2rem;
      }
    }
    .deposit {
      background: @app-theme-color3;
      box-shadow: 0.6rem 1.2rem 2.5rem 0 @app-theme-color1;
    }
    .withdrawal {
      background: @app-theme-color1;
      margin-left: 10rem;
      box-shadow: 0.6rem 1.2rem 2.5rem 0 @app-theme-color1;
    }
  }
  .block3 {
    border-radius: 5.333rem;
    border: 0.533rem solid #814000;
    background-color: @app-theme-color4;
    margin-bottom: 10.667rem;
    padding: 20rem 5.333rem 4rem;
    margin-top: -12rem;
    .block3-1 {
      background-color: #d6b593;
      border: 0.533rem solid #814000;
      padding: 4rem;
      font-size: 3.2rem;
      border-radius: 4rem;
      color: #fffce3;
      display: flex;
      flex-direction: column;
      .l1 {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      .l1, .l2 {
        font-weight: bold;
        margin-bottom: 1.88rem;
      }
    }
    .block3-2 {
      background-color: #d6b593;
      border: 0.533rem solid #814000;
      padding: 2.133rem 0;
      font-size: 3.2rem;
      border-radius: 4rem;
      margin-top: 4rem;
      color: #814000;
      >div {
        padding: 0 3.888rem;
      }
      .service {
        height: 18.667rem;
        padding: 0 3.888rem;
        border-top: 1px solid #814000;
        display: flex;
        align-items: center;
        img {
          width: 12.533rem;
          height: 12.533rem;
          margin-right: 3.888rem;
        }
      }
    }
  }
}
</style>
